module.exports = __webpack_public_path__ + "static/media/03.1af8d72f.jpg";